import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { ProductFilters } from '@entities/Product'


import { SearchProducts } from '@widgets/search-products'



import { ProductFilter } from '@shared/generated'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import PageGrid from '@shared/ui/page-grid'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function SearchPage () {
  const isTablet = useMediaQuery('(max-width: 991px)')
  const [ availableFilters, setAvailableFilters ] = useState<ProductFilter[]>()
  const { t: ts } = useTranslation('search')

  return (
    <Container>
      <PageGrid>
        <Wrapper>
          <div className={styles.grid}>
            <Breadcrumbs
              className={styles.breadcrumbs}
              links={[
                {
                  title: ts('title'),
                },
              ]}
            />

            {!isTablet && availableFilters && (
              <ProductFilters externalFilters={availableFilters} />
            )}
            <SearchProducts
              classNameEmpty={styles['products-empty']}
              onGetFilters={(filters) =>
                setAvailableFilters(filters as ProductFilter[])
              }
            />
          </div>
        </Wrapper>
      </PageGrid>
    </Container>
  )
}
